module.exports = __webpack_public_path__ + "static/hand-eab186668a850ac1c8043b7e87779bba.jpg";